export const isMobile = ():boolean => typeof window !== 'undefined' && window.innerWidth <= 767;

export const isTablet = ():boolean => typeof window !== 'undefined' && window.innerWidth <= 1023;

export const isTabletDown = ():boolean => typeof window !== 'undefined' && window.innerWidth <= 1024;

export const isDesktop = ():boolean => typeof window !== 'undefined' && window.innerWidth >= 1024;

export const isDesktopPro = ():boolean => typeof window !== 'undefined' && window.innerWidth >= 1025;